import BigSalePromotionCouponIcon from './big_sale_promotion_coupon.svg';
import BigSaleTextIcon from './big_sale_text.svg';
import MembershipStandard16x16Icon from './ic__membership_standard__16x16.svg';
import MembershipStandard22x12Icon from './ic__membership_standard__22x12.svg';
import BonuspackClovercon from './ic_clover.svg';
import BonuspackCloverFillIcon from './ic_clover_fill.svg';
import BonuspackCloverFill18x18Icon from './ic_clover_fill_18x18.svg';
import MembershipStandard16x8Icon from './ic_membership_standard_16x8.svg';
import MembershipStandard24x12Icon from './ic_membership_standard_24x12.svg';
import MembershipStandard28x14Icon from './ic_membership_standard_28x14.svg';
import MembershipStandardWithWhiteText98x16Icon from './ic_membership_standard_white_text98x16.svg';
import MembershipLogoIcon from './logo__none__membership.svg';
import MembershipStandard86x14Icon from './membership_standard_icon_86x14.svg';
import MembershipStandardWithGreenText98x16Icon from './membership_standard_icon_98x16.svg';
import MembershipWhiteAndGreen28x14Icon from './white_green_membership_icon_28x14.svg';

// TODO
// 색상 + 뒤에 standard 등 텍스트 유무에 따른 아이콘 네이밍 정리 필요
export {
  BigSalePromotionCouponIcon,
  BigSaleTextIcon,
  BonuspackClovercon,
  BonuspackCloverFill18x18Icon,
  BonuspackCloverFillIcon,
  MembershipLogoIcon,
  MembershipStandard16x8Icon,
  MembershipStandard16x16Icon,
  MembershipStandard22x12Icon,
  MembershipStandard24x12Icon,
  MembershipStandard28x14Icon,
  MembershipStandard86x14Icon,
  MembershipStandardWithGreenText98x16Icon,
  MembershipStandardWithWhiteText98x16Icon,
  MembershipWhiteAndGreen28x14Icon,
};
